import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getCompaniesUnregistered } from 'store/entities/company/thunks';
import { setSelectedCompany } from 'store/entities/company';
import { useHistory } from 'react-router-dom';
import { showErrorNotification } from '../../../utils/notification';

const HeaderSearch = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [searchValue, setSearchValue] = useState('');

  const handleRecaptcha = async name => {
    try {
      const token = await executeRecaptcha('search');
      await dispatch(getCompaniesUnregistered({ name, token }));
    } catch (error) {
      console.error('Recaptcha error:', error);
    }
  };

  const handleSearch = () => {
    if (searchValue.length < 2) {
      showErrorNotification(t('search.input.toShort'), 5);
      return;
    }
    const params = new URLSearchParams({ search: searchValue });
    history.push(`/search/company?${params.toString()}`);
    dispatch(setSelectedCompany(null));
    handleRecaptcha(searchValue);
  };

  return (
    <Input
      className="login-block-input"
      placeholder={t('login.search.placeholder')}
      size="large"
      value={searchValue}
      onChange={e => setSearchValue(e.target.value)}
      onPressEnter={handleSearch}
      suffix={<SearchOutlined onClick={handleSearch} />}
    />
  );
};

export default HeaderSearch;
